"use strict";

var ExportButton = require("app/shared/components/ExportButton/export-button");

var ExportPeopleButton = React.createClass({
  propTypes: {
    onExport: React.PropTypes.func.isRequired,
    skipOptions: React.PropTypes.bool
  },
  getExtraOptions: function(selectionValue) {
    return {
      includeOrgPersonData: (selectionValue >= 1 ? 1 : 0),
      includeProductData: (selectionValue >= 2 ? 1 : 0)
    };
  },
  render: function() {
    let buttonText = this.props.skipOptions ? "Exportar pessoas" : "Exportar";

    let options = [
      {value: 0, checked: true, text: "Pessoas"},
      {value: 1, checked: false, text: "Pessoas + detalhes de Empresas"},
      {value: 2, checked: false, text: "Pessoas + detalhes de Empresas + Produtos"}];
    return <ExportButton onExport={this.props.onExport}
      getExtraOptions={this.getExtraOptions}
      options={options}
      skipOptions={this.props.skipOptions}
      buttonText={buttonText}
      exportName="pessoa" />
  }
});

module.exports = ExportPeopleButton;



// WEBPACK FOOTER //
// ./app/screens/People/components/ExportPeopleButton/export-people-button.jsx